import { ApiResponse, Quantitatives, UrlPath } from './protocols';

const executeRequest = async <T>(props: {
  path: UrlPath;
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  body?: Record<string, unknown>;
  queryParams?: Record<string, string | number | undefined | boolean | null>;
  headers?: Record<string, string>;
  token?: string;
}): Promise<ApiResponse<T>> => {
  try {
    const url = new URL(`${process.env.APP_API_URL}/v1${props.path}`);
    if (props.queryParams !== undefined) {
      Object.entries(props.queryParams).forEach(([key, value]) => {
        if (value !== undefined) {
          url.searchParams.append(key, `${value}`);
        }
      });
    }

    const response = await fetch(url, {
      method: props.method,
      body: props.body !== undefined ? JSON.stringify(props.body) : undefined,
      headers: {
        ...(props.headers ?? {}),
        ...(props.token
          ? {
              Authorization: `Bearer ${props.token}`,
            }
          : {}),
      },
    });

    if (response.ok === false) {
      const reason = await response.text();
      console.info(`API ${response.url} returned "${response.status}" "${reason}"`);
      return response.json();
    }

    let data;

    try {
      data = (await response.json()) as T;
    } catch (error) {
      console.error(`Api call to ${props.path} returned invalid JSON`);
      data = {} as T;
    }

    return {
      data,
      error: undefined,
    };
  } catch (error) {
    const reason = error instanceof Error ? error.message : 'unknown error';
    console.error(`Error while fetching API data: ${reason}`);

    return { data: undefined, error: reason };
  }
};

export const api = {
  generateToken: async (payload: Record<string, unknown>) =>
    executeRequest({
      path: '/gerar_token',
      method: 'POST',
      body: payload,
    }),

  postQuantitatives: async (payload: Record<string, unknown>, token: string) =>
    executeRequest<Quantitatives>({
      path: '/quantitativos',
      method: 'POST',
      body: payload,
      token,
    }),
};
